import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const ArmariosCorrederaPage = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const navigate = useNavigate();

  const whatsappNumber = '34667459830';
  const whatsappMessage = encodeURIComponent('Hola, me gustaría obtener más información sobre Armarios Corredera.');

  const handleConfiguradorClick = () => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById('configurador');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  React.useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const images = [
    'https://benno-design-studio.lovable.app/assets/armarios-corredera-BZcgMxQQ.jpg',
    'https://benno-design-studio.lovable.app/assets/interiores-armarios-B4g1ybcP.jpg',
    'https://benno-design-studio.lovable.app/assets/millenium-_3bubT5B.jpg'
  ];

  const otrosProductos = [
    {
      title: 'Armarios Abatibles',
      description: 'Apertura clásica con acabados premium',
      image: 'https://benno-design-studio.lovable.app/assets/armario-abatible-CYOheyuu.jpg',
      link: '/productos/armarios-abatibles'
    },
    {
      title: 'Armarios Plegables',
      description: 'Soluciones versátiles para cualquier espacio',
      image: 'https://benno-design-studio.lovable.app/assets/armarios-plegables-T-JJjHKj.jpg',
      link: '/productos/armarios-plegables'
    },
    {
      title: 'Modelo Expression',
      description: 'Líneas puras y contemporáneas',
      image: 'https://benno-design-studio.lovable.app/assets/expression-zoaGXKmP.jpg',
      link: '/productos/modelo-expression'
    }
  ];

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div className="min-h-screen bg-black">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-black/95 backdrop-blur-md border-b border-amber-500/20' : 'bg-black/95 backdrop-blur-md border-b border-amber-500/20'}`}>
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-2">
            <img src="https://static.readdy.ai/image/5ec0a551afa550ea327b68ffd2fc4f5a/5325238bb7e02f6b3dd25e9784834fa4.png" alt="Benno Armarios de Diseño" className="h-16 w-auto" />
          </Link>
          <div className="hidden lg:flex items-center gap-2">
            <a href="/#inicio" className="px-5 py-2 text-base font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer text-white hover:text-amber-400">Inicio</a>
            <a href="/#productos" className="px-5 py-2 text-base font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer text-white hover:text-amber-400">Productos</a>
            <a href="/#nosotros" className="px-5 py-2 text-base font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer text-white hover:text-amber-400">Nosotros</a>
            <a href="/#calidades" className="px-5 py-2 text-base font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer text-white hover:text-amber-400">Calidades</a>
            <a href="/#configurador" className="px-6 py-2.5 text-base font-semibold transition-all duration-300 bg-gradient-to-r from-amber-500 to-amber-600 text-black rounded shadow-lg hover:scale-105 whitespace-nowrap cursor-pointer">Configura tu Armario</a>
            <a href="/#contacto" className="px-5 py-2 text-base font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer text-white hover:text-amber-400">Contacto</a>
          </div>
          <button
            className="lg:hidden cursor-pointer text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-black/95 backdrop-blur-md border-t border-amber-500/20">
            <div className="px-6 py-4 space-y-2">
              <a href="/#inicio" className="block px-4 py-3 text-base font-semibold text-white hover:text-amber-400 cursor-pointer" onClick={() => setMobileMenuOpen(false)}>Inicio</a>
              <a href="/#productos" className="block px-4 py-3 text-base font-semibold text-white hover:text-amber-400 cursor-pointer" onClick={() => setMobileMenuOpen(false)}>Productos</a>
              <a href="/#nosotros" className="block px-4 py-3 text-base font-semibold text-white hover:text-amber-400 cursor-pointer" onClick={() => setMobileMenuOpen(false)}>Nosotros</a>
              <a href="/#calidades" className="block px-4 py-3 text-base font-semibold text-white hover:text-amber-400 cursor-pointer" onClick={() => setMobileMenuOpen(false)}>Calidades</a>
              <a href="/#configurador" className="block px-4 py-3 text-base font-semibold bg-gradient-to-r from-amber-500 to-amber-600 text-black rounded text-center cursor-pointer" onClick={() => setMobileMenuOpen(false)}>Configura tu Armario</a>
              <a href="/#contacto" className="block px-4 py-3 text-base font-semibold text-white hover:text-amber-400 cursor-pointer" onClick={() => setMobileMenuOpen(false)}>Contacto</a>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="relative h-[60vh] md:h-[70vh] overflow-hidden">
        <img 
          src="https://benno-design-studio.lovable.app/assets/armarios-corredera-BZcgMxQQ.jpg" 
          alt="Armarios Corredera" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-black/60"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-end pb-16 px-6 text-center z-10">
          <div>
            <Link 
              to="/#productos" 
              className="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-amber-500 transition-colors mb-6 cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              Volver a productos
            </Link>
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-3">
              Armarios Corredera
            </h1>
            <p className="text-lg text-gray-300 tracking-wide max-w-xl mx-auto">
              Sistemas deslizantes de máxima suavidad y diseño
            </p>
          </div>
        </div>
      </section>

      {/* Product Detail Section */}
      <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Image Gallery */}
          <div>
            <div className="relative aspect-[4/3] overflow-hidden bg-neutral-900 rounded">
              <img 
                src={images[currentImage]} 
                alt={`Armarios Corredera - imagen ${currentImage + 1}`}
                className="w-full h-full object-cover"
              />
              <button 
                onClick={prevImage}
                className="absolute left-3 top-1/2 -translate-y-1/2 p-2 bg-black/60 backdrop-blur-sm text-white hover:text-amber-500 transition-colors rounded-full cursor-pointer"
              >
                <i className="ri-arrow-left-s-line text-2xl"></i>
              </button>
              <button 
                onClick={nextImage}
                className="absolute right-3 top-1/2 -translate-y-1/2 p-2 bg-black/60 backdrop-blur-sm text-white hover:text-amber-500 transition-colors rounded-full cursor-pointer"
              >
                <i className="ri-arrow-right-s-line text-2xl"></i>
              </button>
              <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2">
                {images.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentImage(index)}
                    className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                      index === currentImage ? 'bg-amber-500 scale-125' : 'bg-white/40'
                    }`}
                  />
                ))}
              </div>
            </div>
            <div className="flex gap-2 mt-4">
              {images.map((image, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentImage(index)}
                  className={`flex-1 aspect-[4/3] overflow-hidden rounded border-2 transition-all cursor-pointer ${
                    index === currentImage 
                      ? 'border-amber-500' 
                      : 'border-transparent opacity-60 hover:opacity-100'
                  }`}
                >
                  <img src={image} alt="" className="w-full h-full object-cover" />
                </button>
              ))}
            </div>
          </div>

          {/* Product Info */}
          <div>
            <span className="text-amber-500 text-sm tracking-[0.3em] uppercase">Detalle</span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mt-2 mb-8">
              Armarios Corredera
            </h2>
            <div className="space-y-4 mb-10">
              <p className="text-gray-400 leading-relaxed">
                Los armarios de puertas correderas Benno representan la fusión perfecta entre funcionalidad y estética contemporánea. Diseñados para optimizar el espacio disponible, nuestros sistemas deslizantes permiten un acceso cómodo y silencioso a todo el interior del armario.
              </p>
              <p className="text-gray-400 leading-relaxed">
                Cada armario corredera se fabrica a medida, adaptándose perfectamente a las dimensiones y necesidades de tu hogar. Utilizamos guías de rodamiento de alta precisión que garantizan un deslizamiento suave y duradero durante toda la vida útil del producto.
              </p>
              <p className="text-gray-400 leading-relaxed">
                Disponemos de una amplia variedad de acabados: lacados, melaminas, cristales, espejos y combinaciones que permiten crear composiciones únicas y personalizadas.
              </p>
            </div>

            <h3 className="text-xl font-semibold text-white mb-4">Características</h3>
            <ul className="space-y-3 mb-10">
              <li className="flex items-start gap-3 text-sm text-gray-400">
                <i className="ri-check-line text-amber-500 text-lg mt-0.5"></i>
                Sistema de guías con rodamientos de precisión
              </li>
              <li className="flex items-start gap-3 text-sm text-gray-400">
                <i className="ri-check-line text-amber-500 text-lg mt-0.5"></i>
                Cierre suave amortiguado
              </li>
              <li className="flex items-start gap-3 text-sm text-gray-400">
                <i className="ri-check-line text-amber-500 text-lg mt-0.5"></i>
                Perfiles de aluminio en diferentes acabados
              </li>
              <li className="flex items-start gap-3 text-sm text-gray-400">
                <i className="ri-check-line text-amber-500 text-lg mt-0.5"></i>
                Fabricación 100% a medida
              </li>
              <li className="flex items-start gap-3 text-sm text-gray-400">
                <i className="ri-check-line text-amber-500 text-lg mt-0.5"></i>
                Amplia gama de acabados y materiales
              </li>
              <li className="flex items-start gap-3 text-sm text-gray-400">
                <i className="ri-check-line text-amber-500 text-lg mt-0.5"></i>
                Garantía de 5 años
              </li>
            </ul>

            <div className="flex gap-4">
              <button 
                onClick={handleConfiguradorClick}
                className="px-8 py-3 bg-gradient-to-r from-amber-500 to-amber-600 text-black font-semibold text-sm tracking-wider uppercase shadow-lg hover:scale-105 transition-transform whitespace-nowrap cursor-pointer"
              >
                Configura tu armario
              </button>
              <a 
                href="/#contacto" 
                className="px-8 py-3 border border-white/30 text-white font-semibold text-sm tracking-wider uppercase hover:border-amber-500 hover:text-amber-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                Contactar
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Otros Productos Section */}
      <section className="border-t border-amber-500/20 py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-bold text-white text-center mb-12">Otros productos</h2>
          <div className="grid md:grid-cols-3 gap-1">
            {otrosProductos.map((producto, index) => (
              <Link
                key={index}
                to={producto.link}
                className="group relative overflow-hidden aspect-[4/3] cursor-pointer"
              >
                <img 
                  src={producto.image} 
                  alt={producto.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent opacity-60 group-hover:opacity-90 transition-opacity duration-500"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-xl font-bold text-white mb-1">{producto.title}</h3>
                  <p className="text-sm text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    {producto.description}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-12 px-6 border-t border-amber-500/20 bg-black">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 items-center">
            <div className="flex items-center gap-4">
              <img src="https://static.readdy.ai/image/5ec0a551afa550ea327b68ffd2fc4f5a/5325238bb7e02f6b3dd25e9784834fa4.png" alt="Benno Armarios de Diseño" className="h-12 w-auto" />
              <div className="flex items-center gap-3">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-amber-500 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-amber-500 transition-colors cursor-pointer">
                  <i className="ri-twitter-x-line text-xl"></i>
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-amber-500 transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
              </div>
            </div>
            <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-500">
              <a href="/#inicio" className="hover:text-amber-500 transition-colors cursor-pointer">Inicio</a>
              <a href="/#productos" className="hover:text-amber-500 transition-colors cursor-pointer">Productos</a>
              <a href="/#nosotros" className="hover:text-amber-500 transition-colors cursor-pointer">Nosotros</a>
              <a href="/#configurador" className="hover:text-amber-500 transition-colors cursor-pointer">Configurador</a>
              <a href="/#contacto" className="hover:text-amber-500 transition-colors cursor-pointer">Contacto</a>
            </div>
            <p className="text-xs text-gray-600 text-right">
              © 2025 Todos los derechos reservados.
            </p>
          </div>
          <div className="mt-8 pt-6 border-t border-amber-500/10 flex flex-col items-center gap-4">
            <div className="flex flex-wrap justify-center gap-4 text-xs text-gray-600">
              <Link to="/politica-privacidad" className="hover:text-amber-500 transition-colors cursor-pointer">Política de Privacidad</Link>
              <span className="text-amber-500/30">|</span>
              <Link to="/politica-cookies" className="hover:text-amber-500 transition-colors cursor-pointer">Política de Cookies</Link>
              <span className="text-amber-500/30">|</span>
              <Link to="/aviso-legal" className="hover:text-amber-500 transition-colors cursor-pointer">Aviso Legal</Link>
            </div>
            <a className="text-xs text-gray-600 hover:text-amber-500 transition-colors cursor-pointer" href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer">
              Realizado por grupo Globaltis
            </a>
          </div>
        </div>
      </footer>

      {/* WhatsApp Floating Button */}
      <a
        href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300 cursor-pointer group"
        aria-label="Contactar por WhatsApp"
      >
        <i className="ri-whatsapp-line text-white text-3xl"></i>
        <span className="absolute right-full mr-3 px-3 py-2 bg-white text-gray-800 text-sm font-medium rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none">
          ¿Te ayudamos?
        </span>
      </a>
    </div>
  );
};

export default ArmariosCorrederaPage;
